export const readLocalStorage = async (key: string) => {
  try {
    const item = await localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  } catch (error) {
    console.error("Error reading from localStorage:", error);
    return null;
  }
};
